"use strict";
import React, { Component, createRef } from "react";
import classNames from "classnames";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { TabsContext } from "./Tabs";
class TabPanel extends Component {
  constructor() {
    super(...arguments);
    this.panelRef = createRef();
    this.handleResize = (width, height) => {
      this.context.updatePanelHeight(height);
    };
  }
  static {
    this.contextType = TabsContext;
  }
  componentDidMount() {
    this.context.setPanelRef(this.panelRef);
  }
  render() {
    const { children, index, status, className, direction } = this.props;
    const { id } = this.context;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("tabs__tab-panel", `tabs__tab-panel--${status}`, className, {
          [`tabs__tab-panel--${direction === 1 ? "next" : "previous"}`]: !["entered", "entering"].includes(
            status ?? ""
          )
        }),
        role: "tabpanel",
        id: `tabs-${id}-panel-${index}`,
        "aria-labelledby": `tabs-${id}-tab-${index}`,
        ref: this.panelRef,
        tabIndex: -1
      },
      /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleHeight: true, onResize: this.handleResize }),
      children
    );
  }
}
export default TabPanel;
